import React from 'react'
import styled from "styled-components";

const GroupBreakerComponent = (props) => {
    return <div className='b-group-breaker' />
}

export default GroupBreakerComponent;